/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
import { NgModule } from '@angular/core';
import { DataPersistence } from './data-persistence';
/**
 * \@whatItDoes Provides services for enterprise Angular applications.
 *
 * See {\@link DataPersistence} for more information.
 */
import * as ɵngcc0 from '@angular/core';
export class NxModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return { ngModule: NxModule, providers: [DataPersistence] };
    }
}
NxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NxModule });
NxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NxModule_Factory(t) { return new (t || NxModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NxModule, [{
        type: NgModule,
        args: [{}]
    }], null, null); })();

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibngubW9kdWxlLmpzIiwic291cmNlcyI6WyJuZzovQG5yd2wvbngvc3JjL254Lm1vZHVsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEsT0FBTyxFQUF1QixRQUFRLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFDOUQsT0FBTyxFQUFFLGVBQWUsRUFBRSxNQUFNLG9CQUFvQixDQUFDO0FBQ3JEO0FBQ0c7QUFFSDtBQUNBO0FBQ0M7O0FBRUQsTUFBTSxPQUFPLFFBQVE7QUFDckI7QUFBUTtBQUFtQjtBQUFRLElBQWpDLE1BQU0sQ0FBQyxPQUFPO0FBQUssUUFDakIsT0FBTyxFQUFFLFFBQVEsRUFBRSxRQUFRLEVBQUUsU0FBUyxFQUFFLENBQUMsZUFBZSxDQUFDLEVBQUUsQ0FBQztBQUNoRSxJQUFFLENBQUM7QUFDSDtvQ0FMQyxRQUFRLFNBQUMsRUFBRTs7Ozs7MEJBQ1A7QUFBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IE1vZHVsZVdpdGhQcm92aWRlcnMsIE5nTW9kdWxlIH0gZnJvbSAnQGFuZ3VsYXIvY29yZSc7XG5pbXBvcnQgeyBEYXRhUGVyc2lzdGVuY2UgfSBmcm9tICcuL2RhdGEtcGVyc2lzdGVuY2UnO1xuXG4vKipcbiAqIEB3aGF0SXREb2VzIFByb3ZpZGVzIHNlcnZpY2VzIGZvciBlbnRlcnByaXNlIEFuZ3VsYXIgYXBwbGljYXRpb25zLlxuICpcbiAqIFNlZSB7QGxpbmsgRGF0YVBlcnNpc3RlbmNlfSBmb3IgbW9yZSBpbmZvcm1hdGlvbi5cbiAqL1xuQE5nTW9kdWxlKHt9KVxuZXhwb3J0IGNsYXNzIE54TW9kdWxlIHtcbiAgc3RhdGljIGZvclJvb3QoKTogTW9kdWxlV2l0aFByb3ZpZGVycyB7XG4gICAgcmV0dXJuIHsgbmdNb2R1bGU6IE54TW9kdWxlLCBwcm92aWRlcnM6IFtEYXRhUGVyc2lzdGVuY2VdIH07XG4gIH1cbn1cbiJdfQ==